import { Button } from "@cgc/ui/button";

const NavigationButton = (props) => (
  <Button {...props} typoSize="sub3" color="yellow" />
);

export default NavigationButton;
